import React, { Component } from "react";
import Helmet from "react-helmet";
import { Card, Layout, Tabs, Select, Divider } from "antd";
const { Sider, Content } = Layout;
import { withUser } from "@unifiedpatents/sso";
import ToolbarIETF from "./repo/toolbar-ietf";
import RepoTable from "./repo/table";
import DateHistogram from "./repo/date-histogram";
import FieldAggregation from "./repo/field-agg";
import AppliedFilters from "../common/applied-filters";
import CallToLogin from "../common/call-to-login";
import CallToUpgrade from "../common/call-to-upgrade";
import { PUBLIC_ASSETS_URL, API_URL } from "../../config";
import { withRouter } from "react-router";
import { keepOnlyRepoIetfQueryStrings, mapRepoIetfQueryStringToName } from "../../helpers/url";
import { omitBy, isEmpty } from "lodash";
import { toDateString, toSetString } from "../../helpers/converters";

const styles = {
  body: {
    width: "100%",
    padding: 30
  },
  verticalGutter: {
    marginBottom: 16
  }
};

class RepoIeee extends Component {
  state = {
    activeTab: "list",
    fieldCategory: "source",
    fieldDisplaySize: 20,
    fieldDate: "upload_date"
  };

  render() {
    const { activeTab } = this.state;
    const {
      status: { isLoggedIn },
      metadata
    } = this.props.user;
    const accessLevel = metadata.authorization.roles.indexOf("member-ieee-submission-repo") >= 0 ? "full" : isLoggedIn ? "guest" : "public";
    const helmet = {
      title: "IETF Submissions Repository",
      meta: [
        {
          name: "keywords",
          content: "TODO: IETF,,,"
        },
        {
          name: "description",
          content: "TODO: Internet Engineering Task Force,,,"
        }
      ]
    };
    const REPO_IETF_SEARCH_URL = `${API_URL}/repos/ietf/_search`;
    const callToLoginAlert = isLoggedIn ? accessLevel === "full" ? null : <CallToUpgrade style={styles.verticalGutter} /> : <CallToLogin style={styles.verticalGutter} />;
    const filter = this._getFilter(accessLevel);
    const renderHyperLink = (text, record) => <a href={`https://s3-us-west-1.amazonaws.com/sso-document-repository/${record.s3_key}`}>{text}</a>;
    const allCols = [
      { dataIndex: "source", title: "Source", width: 160, render: toSetString },
      { dataIndex: "title", title: "Title", width: 500 },
      { dataIndex: "doc_id", title: "Document ID", width: 300, render: renderHyperLink },
      { dataIndex: "upload_date", title: "Upload Date", width: 120, render: toDateString, sorter: true, key: "upload_date" },
      { dataIndex: "version", title: "Version", width: 60 },
      { dataIndex: "authors", title: "Authors", width: 160, render: toSetString }
    ];
    const selectedColumns = ["doc_id", "version", "upload_date", "title", "source", "authors"];
    return (
      <div style={styles.body}>
        <Helmet {...helmet} />
        {callToLoginAlert}
        <Layout>
          <Sider width={260} breakpoint="lg" collapsedWidth="0" style={{ background: "transparent", marginRight: 16 }}>
            <Card style={styles.verticalGutter} bodyStyle={{ textAlign: "center" }}>
              <img alt="OPEN Logo" src={`${PUBLIC_ASSETS_URL}/open_logo.png`} height={45} style={{ marginBottom: 8 }} />
              <br />
              <a href="" target="_new">
                Learn More
              </a>
            </Card>
            <ToolbarIETF accessLevel={accessLevel} esUrl={REPO_IETF_SEARCH_URL} />
          </Sider>
          <Content>
            <AppliedFilters fieldSelector={keepOnlyRepoIetfQueryStrings} fieldMapper={mapRepoIetfQueryStringToName} />
            <Tabs size="small" activeKey={activeTab} onChange={val => this.setState({ activeTab: val })} tabBarStyle={{ marginBottom: 0 }}>
              <Tabs.TabPane tab="Doc List" key="list" />
              <Tabs.TabPane tab="Analytics" key="analytics" disabled={false} />
            </Tabs>
            {activeTab === "list" && (
              <RepoTable
                filter={filter}
                accessLevel={accessLevel}
                esUrl={REPO_IETF_SEARCH_URL}
                allCols={allCols}
                selectedColumns={selectedColumns}
                defaultSort={"-upload_date"}
                tableKey="repoIETF"
                rowKey="doc_id"
                key={JSON.stringify(filter)}
              />
            )}
            {activeTab === "analytics" && (
              <Card>
                <div style={{ textAlign: "center" }}>
                  <Select
                    value={this.state.fieldCategory}
                    placeholder="Drill-Down By"
                    onChange={val => this.setState({ fieldCategory: val })}
                    getPopupContainer={trigger => trigger.parentNode}
                    style={{ width: 160 }}
                  >
                    {[
                      { value: "source", label: "Source" },
                      { value: "authors", label: "Authors" }
                    ].map((e, i) => (
                      <Select.Option value={e.value} key={i}>
                        {e.label}
                      </Select.Option>
                    ))}
                  </Select>
                  <Divider type="vertical" />
                  <Select
                    value={this.state.fieldDrilldownCategory}
                    placeholder="Drill-Down By"
                    onChange={val => this.setState({ fieldDrilldownCategory: val })}
                    getPopupContainer={trigger => trigger.parentNode}
                    style={{ width: 160 }}
                  >
                    {[
                      { value: "", label: "None" },
                      { value: "source", label: "Source" },
                      { value: "authors", label: "Authors" }
                    ].map((e, i) => (
                      <Select.Option value={e.value} key={i}>
                        {e.label}
                      </Select.Option>
                    ))}
                  </Select>
                  <Divider type="vertical" />
                  <Select
                    value={this.state.fieldDisplaySize}
                    placeholder="Display Size"
                    onChange={val => this.setState({ fieldDisplaySize: val })}
                    getPopupContainer={trigger => trigger.parentNode}
                    style={{ width: 130 }}
                  >
                    {[20, 50, 100].map(e => (
                      <Select.Option value={e} key={e}>{`Show Top ${e}`}</Select.Option>
                    ))}
                  </Select>
                  <FieldAggregation
                    field={this.state.fieldCategory}
                    field2={this.state.fieldDrilldownCategory}
                    size={this.state.fieldDisplaySize}
                    filter={filter}
                    fieldsWideLabel={["author"]}
                    esUrl={REPO_IETF_SEARCH_URL}
                  />
                </div>
                <Divider />
                <div style={{ textAlign: "center" }}>
                  <Select value={this.state.fieldDate} onChange={val => this.setState({ fieldDate: val })} getPopupContainer={trigger => trigger.parentNode} style={{ width: 180 }}>
                    <Select.Option value="upload_date">{"Upload Date"}</Select.Option>
                  </Select>
                  <Divider type="vertical" />
                  <Select
                    value={this.state.fieldDrilldownDate}
                    placeholder="Drill-Down By"
                    onChange={val => this.setState({ fieldDrilldownDate: val })}
                    getPopupContainer={trigger => trigger.parentNode}
                    style={{ width: 180 }}
                  >
                    {[
                      { value: "", label: "None" },
                      { value: "source", label: "Source" },
                      { value: "authors", label: "Authors" }
                    ].map((e, i) => (
                      <Select.Option value={e.value} key={i}>
                        {e.label}
                      </Select.Option>
                    ))}
                  </Select>
                </div>
                <DateHistogram field={this.state.fieldDate} field2={this.state.fieldDrilldownDate} filter={filter} esUrl={REPO_IETF_SEARCH_URL} />
              </Card>
            )}
          </Content>
        </Layout>
      </div>
    );
  }

  _getFilter = accessLevel => {
    let query = keepOnlyRepoIetfQueryStrings(this.props.location.query);
    if (accessLevel !== "full") {
      if (query.full_text && query.full_text != "example") {
        query.full_text = "example";
      }
    }
    return omitBy(query, isEmpty);
  };
}

export default withUser(withRouter(RepoIeee));
